module.exports = __webpack_public_path__ + "static/media/tatapower.9429cfb3.svg";